"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSuiTheme = exports["default"] = void 0;
var _themes = require("baseStyles/ThemeProvider/themes");
var _react = _interopRequireWildcard(require("react"));
var _themePallete = require("./themePallete");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
;
var ThemeProviderContext = /*#__PURE__*/_react["default"].createContext({
  theme: _themes.Themes[_themes.ThemesName["default"]],
  themeName: _themes.ThemesName["default"]
});
var SuiThemeProvider = function SuiThemeProvider(_ref) {
  var children = _ref.children,
    themeName = _ref.themeName;
  var _useState = (0, _react.useState)(_themes.ThemesName["default"]),
    _useState2 = _slicedToArray(_useState, 2),
    currentTheme = _useState2[0],
    setThemeName = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    customTheme = _useState4[0],
    setCustomTheme = _useState4[1];
  (0, _react.useEffect)(function () {
    if (_themes.Themes[themeName]) {
      setCustomTheme(null);
      setThemeName(themeName);
    }
  }, [themeName]);
  var theme = (0, _react.useMemo)(function () {
    return customTheme || _themes.Themes[currentTheme];
  }, [currentTheme, customTheme]);
  var ThemeProviderState = {
    theme: theme,
    themeName: currentTheme
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ThemeProviderContext.Provider, {
    value: ThemeProviderState,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "index.tsx"
  }, children), /*#__PURE__*/_react["default"].createElement(_themePallete.ThemePallete, {
    setCustomTheme: setCustomTheme,
    setThemeName: setThemeName,
    "data-sentry-element": "ThemePallete",
    "data-sentry-source-file": "index.tsx"
  }));
};
var _useSuiTheme = exports.useSuiTheme = function useSuiTheme() {
  var context = (0, _react.useContext)(ThemeProviderContext);
  if (!context.theme) {
    // throw Error(`Use ${useThemeProviderState.name} in ${ThemeProviderContext.displayName}`);
    console.warn("Use ".concat(_useSuiTheme.name, " in ").concat(ThemeProviderContext.displayName));
  }
  return context;
};
var _default = exports["default"] = SuiThemeProvider;